import React from 'react';
import PropTypes from 'prop-types';
import { Home, RefreshCw, DollarSign } from 'lucide-react';
import { CardSelect, SectionHeader, FormNavigation } from '../FormComponents';

const loanPurposeOptions = [
  { value: 'purchase', label: 'Purchase', icon: <Home size={24} />, description: 'Buy a new home' },
  { value: 'refinance', label: 'Refinance', icon: <RefreshCw size={24} />, description: 'Lower your rate' },
  { value: 'cashout', label: 'Cash-Out', icon: <DollarSign size={24} />, description: 'Access equity' },
];

const propertyTypeOptions = [
  { value: 'single-family', label: 'Single Family' },
  { value: 'condo', label: 'Condo' },
  { value: 'townhouse', label: 'Townhouse' },
  { value: 'multi-family', label: 'Multi-Family' },
];

const propertyUseOptions = [
  { value: 'primary', label: 'Primary Residence', description: "Where you'll live" },
  { value: 'secondary', label: 'Second Home', description: 'Vacation property' },
  { value: 'investment', label: 'Investment', description: 'Rental property' },
];

export default function GettingStarted({ data, onChange, onNext }) {
  const updateField = (field, value) => {
    onChange({ ...data, [field]: value });
  };

  const isValid = data.loanPurpose && data.propertyType && data.propertyUse;

  return (
    <div>
      <SectionHeader
        title="Let's Get Started"
        subtitle="Tell us about your home financing goals"
        icon={<Home size={28} />}
      />

      <CardSelect
        label="What would you like to do?"
        value={data.loanPurpose}
        onChange={(value) => updateField('loanPurpose', value)}
        options={loanPurposeOptions}
        required
        columns={3}
      />

      <CardSelect
        label="What type of property?"
        value={data.propertyType}
        onChange={(value) => updateField('propertyType', value)}
        options={propertyTypeOptions}
        required
        columns={4}
      />

      <CardSelect
        label="How will you use this property?"
        value={data.propertyUse}
        onChange={(value) => updateField('propertyUse', value)}
        options={propertyUseOptions}
        required
        columns={3}
      />

      <FormNavigation
        onNext={onNext}
        isFirstSection={true}
        isValid={isValid}
      />
    </div>
  );
}

GettingStarted.propTypes = {
  data: PropTypes.shape({
    loanPurpose: PropTypes.string,
    propertyType: PropTypes.string,
    propertyUse: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
};
